var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":"none"}},[_c('circle',{attrs:{"cx":"40","cy":"40","r":"40","fill":"#006DB6"}}),_c('path',{attrs:{"d":"M56.5293 39.9998L31.488 57.7497L31.488 22.2498L56.5293 39.9998Z","fill":"white"}})])}
var staticRenderFns = []

export { render, staticRenderFns }